import { css } from "@emotion/react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import BaseLink from "~/components/links/BaseLink";

import FaIcon from "~/components/FaIcon";

import { link } from "~/styles/typographyStyles";

import transition from "~/utilities/transition";

import { iconLinkColors } from "~/theme";

const getColor = ({ color, theme }) => {
    return css`
        color: ${theme.iconLinkColors[color].color};

        &:hover,
        &:focus {
            color: ${theme.iconLinkColors[color].hover};
        }
    `;
};

const Link = styled(BaseLink)`
    ${transition({}, "color")};
    ${link};
    ${getColor};
    display: ${({ fullWidth }) => (fullWidth ? `flex` : `inline-flex`)};
    flex-direction: ${({ iconLast }) => (iconLast ? `row-reverse` : `row`)};
    justify-content: ${({ iconLast, iconRight }) =>
        iconLast && iconRight
            ? `space-between`
            : iconLast
              ? "flex-end"
              : `flex-start`};
    align-items: center;
`;

const Text = styled.span`
    line-height: 1.2;
`;

const Icon = styled(FaIcon)`
    font-size: 2rem;
    margin: ${({ iconLast }) => (iconLast ? `0 0 0 10px` : `0 10px 0 0`)};
`;

const IconLink = ({
    children,
    to,
    icon = "",
    iconLast = false,
    iconRight = false,
    color = Object.keys(iconLinkColors)[0],
    fullWidth = false,
    ...props
}) => (
    <Link {...{ iconLast, color, fullWidth, iconRight }} {...props} to={to}>
        {icon ? <Icon {...{ iconLast }} name={icon} /> : null}
        <Text>{children}</Text>
    </Link>
);

IconLink.propTypes = {
    children: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconLast: PropTypes.bool,
    iconRight: PropTypes.bool,
    color: PropTypes.oneOf(Object.keys(iconLinkColors)),
    fullWidth: PropTypes.bool,
};

export default IconLink;
